import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect } from 'omni-common-ui';
import ClassroomSessionNav from 'components/ClassroomSessionNav';
import { actions as Session } from 'data/SessionPlans';
import { actions as Group } from 'containers/Group';
import { actions as UiState } from 'data/UiState';
import { getNextUnit, getPreviousUnit, getUnitList } from 'data/Units/accessors';

class SessionNav extends PureComponent {
  render() {
    const {
      currentSession,
      timeZone,
    } = this.props;

    if (! is.existy(currentSession) || ! is.existy(timeZone)) {
      return null;
    }
    return <ClassroomSessionNav currentLinkHref={this.props.currentLinkHref}
        currentSessionStartDate={currentSession.period.start.clone().tz(timeZone)}
        currentSessionEndDate={currentSession.period.end.clone().tz(timeZone)}
        currentSessionNumber={this.props.currentSessionIndex + 1}
        currentSessionType={currentSession.sessionType}
        currentGroupName={this.props.groupName}
        currentSessionId={this.props.currentSessionId}
        currentUnit={this.props.currentUnit}
        nextSessionLinkHref={this.props.nextSessionLinkHref}
        nextUnitLinkHref={this.props.nextUnitLinkHref}
        nextUnitText={this.props.nextUnitText}
        previousSessionLinkHref={this.props.previousSessionLinkHref}
        previousUnitLinkHref={this.props.previousUnitLinkHref}
        previousUnitText={this.props.previousUnitText}
        sessionCount={this.props.sessionCount}
        isHide={! this.props.showNavigationBar}
        showCurrentNav
        shouldShowTime={this.props.shouldShowTime}
        showUnitNav={this.props.shouldShowUnitNav} />;
  }
}

SessionNav.propTypes = {
  groupName: PropTypes.string,
  timeZone: PropTypes.string,
  currentLinkHref: PropTypes.string,
  currentSession: PropTypes.object,
  currentSessionIndex: PropTypes.number,
  currentUnit: PropTypes.string,
  currentSessionId: PropTypes.string,
  nextSessionLinkHref: PropTypes.string,
  nextUnitLinkHref: PropTypes.string,
  nextUnitText: PropTypes.string,
  previousSessionLinkHref: PropTypes.string,
  previousUnitLinkHref: PropTypes.string,
  previousUnitText: PropTypes.string,
  shouldShowUnitNav: PropTypes.bool,
  sessionCount: PropTypes.number,
  showNavigationBar: PropTypes.bool,
  shouldShowTime: PropTypes.bool,
};

function getSessionLinkHref(sessionPlan, buildRoute) {
  const sessionPlanId = sessionPlan && sessionPlan.id;
  const unitId = sessionPlanId &&
    Array.isArray(sessionPlan.unitIds) &&
    sessionPlan.unitIds[0];

  const params = is.existy(unitId) ?
    { unitId, sessionPlanId, mode: '' } :
    { unitId: 0, sessionPlanId, mode: '' };
  return sessionPlanId && buildRoute(params);
}

function getPreviousOrNextSession(sessionList, currentSessionIndex, previous) {
  const previousOrNextSession = sessionList.get(previous ?
  currentSessionIndex - 1 : currentSessionIndex + 1);
  return previousOrNextSession;
}

function getUnitLinkHref(session, unitId, buildRoute) {
  return unitId && session && buildRoute({
    unitId,
    sessionPlanId: session.id,
    mode: '',
  });
}

function isSessionContainsUnit(session, unitId) {
  if (is.existy(unitId)) {
    session.unitIds.includes(unitId);
  }
  return false;
}

export function mapStateToProps(state, ownProps) {
  const { groupId, sessionPlanId: currentSessionId } = ownProps.params;
  if (! is.existy(groupId) || ! is.existy(currentSessionId)) {
    return;
  }
  const { buildRoute } = ownProps;
  const group = state.get('rootReducer').get('groups').get(groupId) &&
    state.get('rootReducer').get('groups').get(groupId).data;
  const sessions = Session.getSessions(state, groupId);
  const units = getUnitList(state, groupId);
  if (is.existy(group) && is.existy(sessions) && sessions.size !== 0 && is.existy(units)) {
    const { timeZone } = Group.getCentre(state, groupId);
    const sessionList = Session.getOrderSessions(state, groupId);
    const currentUnitId = is.existy(ownProps.params.unitId) ?
      ownProps.params.unitId :
      Session.getFirstUnitOfSession(state, currentSessionId);
    const defaultSession = Session.getDefaultSession(state, groupId);
    const currentSession = sessions.get(currentSessionId);
    const currentSessionIndex = currentSession.index - 1;
    const previousSession = getPreviousOrNextSession(sessionList, currentSessionIndex, true);
    const nextSession = getPreviousOrNextSession(sessionList, currentSessionIndex, false);
    const nextUnitId = currentUnitId > 0 ?
      getNextUnit(state, currentUnitId, groupId) && getNextUnit(state, currentUnitId, groupId).id :
      Session.getNextUnitIdBySessionId(state, groupId, currentSessionId);
    const previousUnitId = currentUnitId > 0 ?
      getPreviousUnit(state, currentUnitId, groupId) &&
          getPreviousUnit(state, currentUnitId, groupId).id :
      Session.getPreviousUnitIdBySessionId(state, groupId, currentSessionId);
    const nextUnitHref = isSessionContainsUnit(currentSession, nextUnitId) ?
        getUnitLinkHref(currentSession, nextUnitId, buildRoute) :
        getUnitLinkHref(
          Session.getFirstSessionOfUnit(
            state,
            groupId,
            nextUnitId),
          nextUnitId,
          buildRoute);
    const previousUnitHref = isSessionContainsUnit(currentSession, previousUnitId) ?
        getUnitLinkHref(currentSession, previousUnitId, buildRoute) :
        getUnitLinkHref(
          Session.getFirstSessionOfUnit(
            state,
            groupId,
            previousUnitId),
          previousUnitId,
          buildRoute);
    const nextUnit = units.get(nextUnitId);
    const previousUnit = units.get(previousUnitId);
    const nextUnitText = nextUnit && `U ${nextUnit.orderingSequence}`;
    const previousUnitText = previousUnit && `U ${previousUnit.orderingSequence}`;
    const shouldShowUnitNav = !! (units && units.size !== 0);
    const currentUnit = units.get(currentUnitId);
    return {
      shouldShowTime: ownProps.shouldShowTime,
      timeZone,
      currentLinkHref: getSessionLinkHref(defaultSession, buildRoute),
      currentSession,
      currentSessionIndex,
      groupName: group.name,
      currentSessionId,
      currentUnit,
      nextSessionLinkHref: getSessionLinkHref(
        nextSession,
        buildRoute),
      nextUnitLinkHref: nextUnitHref,
      nextUnitText,
      previousSessionLinkHref: getSessionLinkHref(
        previousSession,
        buildRoute),
      previousUnitLinkHref: previousUnitHref,
      previousUnitText,
      shouldShowUnitNav,
      sessionCount: sessions.size,
      showNavigationBar: UiState.getShowNavigationBar(state),
    };
  }
}

export default connect(mapStateToProps, null)(SessionNav);



// WEBPACK FOOTER //
// ./containers/Group/SessionNav/index.jsx